import React, { createContext, useReducer } from "react";
import { AssociatePerformanceReducer } from "../reducers/AssociatePerformanceReducer";

export const AssociatePerformanceContext = createContext()

const AssociatePerformanceContextProvider = (props) => {
    const state = {
        sortPref: { column: "alias", direction: "ascending" },
        associatePerformance: [],
    }
    const [viewModel, dispatch] = useReducer(AssociatePerformanceReducer, state);
    return (
        <AssociatePerformanceContext.Provider value={{ viewModel, dispatch }}>
            {props.children}
        </AssociatePerformanceContext.Provider>
    )
}

export default AssociatePerformanceContextProvider


// WEBPACK FOOTER //
// ./src/components/stageassociate/context/AssociatePerformanceContext.js